import React from 'react';

const BusinessPolicy = () => {
    return (
        <div className='mx-2'>
            <h2 className='text-center text-2xl text-orange-400 font-bold my-4 underline'>Our Policy</h2>
            <div className='lg:w-2/5 mx-auto border border-yellow-500 p-2'>
                <h5 className='my-2'>All of our products are original. Reputation is our main asset. We can not consider in this. So, please give us all the original and branded products. If any supplier tries to do worng We must take take the step against them. We believe in original and we are original.   </h5>
                <h5>Customers are very satisfied with our products inspite of higher range price. Because, products are the best</h5>
                <h5 className='my-4'>For customer review, We have decided that There are no sacrifice in original. Nothing can replace original. So, Please give us Original</h5>
                <div className=''>
                    <h4 className='text-red-500 text-xl font-bold'>Thank You</h4>
                </div>
            </div>
        </div>
    );
};

export default BusinessPolicy;